import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { Stack, InputAdornment } from '@mui/material';
import type { ReactNode, ForwardedRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CardExpirationInput,
  CardNumberInput,
  TaxIDInputFormik,
  TextField,
} from '@woovi/form';

type PaymentActiveWaitingPaymentMethodCreditCardFormFieldsArgs = {
  addressFieldRef: ForwardedRef<HTMLInputElement>;
  toggleModal: () => void;
};

export const PaymentActiveWaitingPaymentMethodCreditCardFormFields = ({
  toggleModal,
  addressFieldRef,
}: PaymentActiveWaitingPaymentMethodCreditCardFormFieldsArgs): ReactNode => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: 2 }}>
      <CardNumberInput
        name='number'
        label={t('Card number')}
        placeholder={t('Card number')}
        sx={{ m: 0 }}
      />
      <Stack
        sx={{
          gap: 2,
          '@media (min-width: 600px)': {
            gap: 1.5,
            direction: 'row',
          },
        }}
      >
        <CardExpirationInput
          name='expireDate'
          label={t('Expiration Date')}
          placeholder={t('Expiration Date')}
          fullWidth
          sx={{ m: 0 }}
        />
        <TextField
          name='cvv'
          label={t('CVV')}
          placeholder={t('CVV')}
          fullWidth
          sx={{ m: 0 }}
          inputProps={{
            minLength: 3,
            maxLength: 4,
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          onKeyDown={(e) => {
            if (
              !/^[0-9]$/.test(e.key) &&
              !['Backspace', 'Delete'].includes(e.key)
            ) {
              e.preventDefault();
            }
          }}
        />
      </Stack>
      <TextField
        name='holderName'
        label={t('Name as it appears on the card')}
        placeholder={t('Name as it appears on the card')}
        sx={{ m: 0 }}
        inputProps={{
          minLength: 3,
          maxLength: 140,
          pattern: '*',
        }}
      />
      <TaxIDInputFormik
        name='holderTaxID'
        label={t('CPF or CNPJ')}
        placeholder={t('CPF or CNPJ')}
        sx={{ m: 0 }}
        inputProps={{
          inputMode: 'numeric',
        }}
      />
      <TextField
        inputRef={addressFieldRef}
        readOnly
        name='billingAddress'
        label={t('Billing address')}
        placeholder={t('Billing address')}
        onFocus={toggleModal}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <ModeEditIcon sx={{ cursor: 'pointer' }} onClick={toggleModal} />
            </InputAdornment>
          ),
        }}
        sx={{ m: 0 }}
      />
    </Stack>
  );
};
